function handlerZero(param) {
  // 小于10补零
  param = param < 10 ? "0" + param : param;
  return param;
}

function newround(n, m) {
  //此处的n表示要四舍五入的数，m为要保留的小数位数
  return Math.round(n * Math.pow(10, m)) / Math.pow(10, m);
}

// 国标时间 转 年月日 时分秒
export function formatDateTime(date) {
  let y = date.getFullYear();
  let m = date.getMonth() + 1;
  let d = date.getDate();
  let h = date.getHours();
  let mi = date.getMinutes();
  let ss = date.getSeconds();
  return `${y}-${handlerZero(m)}-${handlerZero(d)} ${handlerZero(
    h
  )}:${handlerZero(mi)}`;
}

// 获取查询字符串字典
export function getQueryStringArgs() {
  //取得查询字符串并去掉开头的问号
  var qs =
      window.location.search.length > 0
        ? window.location.search.substring(1)
        : "",
    //保存数据的对象
    args = {},
    //取得每一项
    items = qs.length ? qs.split("&") : [], //split(separator,howmany) 方法用于把一个字符串分割成字符串数组
    item = null,
    name = null,
    value = null,
    //在 for 循环中使用
    i = 0,
    len = items.length;
  //逐个将每一项添加到 args 对象中
  for (i = 0; i < len; i++) {
    item = items[i].split("=");
    name = decodeURIComponent(item[0]);
    value = decodeURIComponent(item[1]);
    if (name.length) {
      args[name] = value;
    }
  }
  return args;
}

export function checkMobile() {
  var userAgent = navigator.userAgent;
  if (/Mobile|Android|iPhone/.test(userAgent)) {
    // 访问设备是手机
    return true;
  } else {
    // 访问设备不是手机
    return false;
  }
}

// 获取随机分类颜色
let colorNum;
const categoryColorDict = {};
export function getCategoryColor(category) {
  const colors = [
    "rgb(253, 200, 149)", // 橘色
    "rgb(255 181 181)", // 淡红
    "rgb(255 242 181)", // 淡绿
    "rgb(181 239 255)", // 淡蓝
    "rgb(189 181 255)", // 淡靛
    "rgb(255 181 197)", // 粉红
    "rgb(245 181 255)", // 淡紫
  ];
  let color = categoryColorDict[category];
  if (color == undefined) {
    if (colorNum == undefined) {
      colorNum = 0;
    } else {
      colorNum += 1;
    }

    color = colors[colorNum % colors.length];
    categoryColorDict[category] = color;
    return color;
  } else {
    return color;
  }
}

// 规范化搜索输入
export function normalizeSearchInput(input) {
  return input
    .trim()                       // 去掉首尾空格
    .replace(/\s+/g, " ")         // 多个空格压缩成一个
    .normalize("NFKC")            // Unicode 规范化（全角转半角等）
    .replace(/[<>]/g, "");        // 移除危险字符，防止 XSS
}